import Vue from 'vue'
import state from './dashboard_state'

function saveWidget(state, widget) {
    if (!state.widgets[widget.i]) {
        Vue.set(state.widgets, widget.i, widget)
        return
    }
    Object.assign(state.widgets[widget.i], widget)
}

function saveDashboard(state, updatedDashboard) {
    var type = updatedDashboard.type
    var dashboardsForType = state.typeLookup[type]
    if (!dashboardsForType) {
        dashboardsForType = []
        Vue.set(state.typeLookup, type, dashboardsForType)
    }
    if (!dashboardsForType.any((d) => d.id == updatedDashboard.id)) {
        dashboardsForType.push({
            id: updatedDashboard.id,
            isActive: true,
            type
        })
    }

    var currentDashboard = state.dashboards[updatedDashboard.id]
    if (!currentDashboard) {
        Vue.set(state.dashboards, updatedDashboard.id, updatedDashboard)
        return
    }

    // find all removed widgets
    currentDashboard.widgetIds
        .where((wId) => !updatedDashboard.widgetIds.contains(wId))
        .forEach((removedId) => delete state.widgets[removedId])

    Object.assign(currentDashboard, updatedDashboard)
}

export default {
    SAVE_DASHBOARD(state, { id, name, type, widgets }) {
        var widgetIds = widgets.map((w) => {
            w.dashboardId = id
            saveWidget(state, w)
            return w.i
        })
        saveDashboard(state, {
            id,
            name,
            type,
            widgetIds
        })
    },
    SET_CURRENT_DRAGGED_WIDGET(state, widget) {
        state.currentDraggedWidget = widget
    },
    SAVE_WIDGET(state, widget) {
        saveWidget(state, widget)
    },
    SET_DASHBOARD_TYPES(state, dashboardRefs) {
        state.typeLookup = dashboardRefs.groupBy((t) => t.type)
    },
    REMOVE_WIDGET(state, widgetId) {
        var widget = state.widgets[widgetId]
        if (!widget) {
            return
        }
        var dashboardId = widget.dashboardId
        var dashboard = state.dashboards[dashboardId]

        dashboard.widgetIds.remove(widgetId)
        Vue.delete(state.widgets, widgetId)
    },
    CLEAR(vuex_state) {
        Object.assign(vuex_state, state())
    }
}
